import React from 'react';
import { connect } from 'react-redux';
import '../../../assets/styles/components/cash-account.scss';
import { PARAMS } from '../../../constants/params';
import { SERVICES_RESP, settingConfigs } from '../../../configurations';
import { Converter } from '../../../helpers/functions';
import { getAssetAllocation, getPortfolioAction } from '../../../actions/trading';
import { getSafe } from '../../../helpers/global';
import { colorBindingTypes as colorTypes } from '../../../constants/color-binding-type';
import RefreshIcon from '../../../assets/images/icons/icon_refresh.png';
import { Icons } from '../../../configurations';

class CashAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cashAccountData: {},
      portfolioData: {},
      isLoading: false
    }
  }

  render() {
    const { language } = this.props;
    const { cashAccountData, portfolioData, isLoading } = this.state;

    return (
      <React.Fragment>
        <div className="cash-account-container">
          <div className="actions-item">
            {isLoading && <Icons.Loading />}
            <img onClick={this.handleRefresh}
              className="pointer img-icon-12" src={RefreshIcon} alt='refresh_icon' />
          </div>
          <div className="grids-top-bar">
            <div className="grid-item-flex">
              <div className="item-flex" style={{ flexDirection: 'row', flex: 1, alignItems: 'center' }}>
                <div className="item-label">{getSafe(() => language.current_account_net_assets)} ({cashAccountData.ccy})</div>
                <div className="item-value">{cashAccountData.value}</div>
              </div>
              {/* <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_position_PL)}</div>
                <div className="item-value"
                  style={Converter.colorMapping(
                    colorTypes.UP_DOWN,
                    getSafe(() => portfolioData.floatingPL.replaceAll(settingConfigs.PRICE.thousandSeparator, ''), 0)
                  )}>
                  <span>{portfolioData.floatingPL ?
                    (Number(portfolioData.floatingPL) > 0 ? `+${portfolioData.floatingPL}` : (Number(portfolioData.floatingPL) === 0 ? `${portfolioData.floatingPL}` : `${portfolioData.floatingPL}`)) :
                    0}</span>
                  <span> ({portfolioData.floatingPLPercent ?
                    (Number(portfolioData.floatingPLPercent) > 0 ? `+${portfolioData.floatingPLPercent}` : (Number(portfolioData.floatingPLPercent) === 0 ? `${portfolioData.floatingPLPercent}` : `${portfolioData.floatingPLPercent}`)) :
                    `0%`})</span>
                </div>
              </div> */}

            </div>
          </div>
          <div className="grids-content">
            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_market_value)}</div>
                <div className="item-value" style={Converter.colorMapping(colorTypes.MARGIN)}>{cashAccountData.marketValue}</div>
              </div>
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_pending_balance)}</div>
                <div className="item-value">{cashAccountData.pendingBal}</div>
              </div>
            </div>

            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_buying_power)}</div>
                <div className="item-value" style={Converter.colorMapping(colorTypes.BUYING_POWER)}>{cashAccountData.buyingPower}</div>
              </div>
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_settled_balance)}</div>
                <div className="item-value">{cashAccountData.settledBalance}</div>
              </div>
              {/* <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_withdrawable_balance)}</div>
                <div className="item-value">{cashAccountData.withdrawableBal}</div>
              </div> */}
            </div>

            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_hold_amount)}</div>
                <div className="item-value" style={Converter.colorMapping(colorTypes.HOLD_AMOUNT)}>{cashAccountData.holdAmount}</div>
              </div>
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_ledger_balance)}</div>
                <div className="item-value">{cashAccountData.ledgerBal}</div>
              </div>
            </div>

            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_margin_Value)}</div>
                <div className="item-value">{cashAccountData.marginValue}</div>
              </div>
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_today_confirm_sell)}</div>
                <div className="item-value">{cashAccountData.todayConfirmSell}</div>
              </div>
            </div>

            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_today_confirm_buy)}</div>
                <div className="item-value">{cashAccountData.todayConfirmBuy}</div>
              </div>
              <div className="item-flex">
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  handleRefresh = () => {
    this.getCashAccount();
    this.getPortfolio();
  }

  getCashAccount = () => {
    const { currentTradingAccount, language } = this.props;
    const { clientID, tradingAccSeq } = currentTradingAccount
    const params = {
      [PARAMS.CLIENT_ID]: clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: clientID,
      [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
      [PARAMS.LANGUAGE]: language.lang
    }
    this.setState({ isLoading: true })
    if (clientID) {
      this.props.getCashAccount(params, res => {
        if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          this.setState({
            isLoading: false,
            cashAccountData: Converter.mapAssetAllocation(res)
          })
        }
      })
    } else {
      this.setState({
        isLoading: false,
        cashAccountData: Converter.mapAssetAllocation({})
      })
    }
  }

  getPortfolio = () => {
    const { currentTradingAccount, language } = this.props;
    const { clientID, tradingAccSeq } = currentTradingAccount
    const params = {
      [PARAMS.CLIENT_ID]: clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: clientID,
      [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
      [PARAMS.LANGUAGE]: language.lang
    }
    this.props.getPortfolio(params, res => {
      if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({
          portfolioData: Converter.mapAccountPL(res)
        })
      }
    })
  }

  componentDidUpdate(prevProps) {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
      if(JSON.stringify(prevProps.currentTradingAccount) !== "{}"){
        this.getCashAccount()
      }
    }
    if (this.props.token && this.props.token !== prevProps.token) {
      this.getCashAccount();
    }
    if (this.props.clientID !== prevProps.clientID) {
      this.getCashAccount();
    }
    // if (this.props.portfolios !== prevProps.portfolios) {
    //   this.setState({
    //     portfolioData: Converter.mapAccountPL(this.props.portfolios)
    //   })
    // }
  }

  componentDidMount() {
    const { currentTradingAccount, token } = this.props;
    if (token && currentTradingAccount) {
      this.getCashAccount();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
    clientID: state.trade.clientID,
    portfolios: state.trade.portfolios,
    token: state.auth.token
  }),
  dispatch => ({
    getCashAccount: (p, res) => dispatch(getAssetAllocation(p, res)),
    getPortfolio: (p, res) => dispatch(getPortfolioAction(p, res)),
  })
)(CashAccount)
